import React, { useState, useEffect } from 'react';
import { X, Check, XCircle, UserPlus, Loader2, MessageSquare, Maximize2, Minimize2 } from 'lucide-react';
import api from '../api';

const EnrollmentManagementModal = ({ onClose }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await api.get('subjects/pending-enrollments/');
      setRequests(res.data);
    } catch (err) {
      console.error('Error fetching pending enrollments:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleProcess = async (requestId, action) => {
    setProcessingId(requestId);
    try {
      await api.post('subjects/process-enrollment/', {
        request_id: requestId,
        action: action
      });
      // Refresh list
      setRequests(requests.filter(req => req.id !== requestId));
    } catch (err) {
      console.error(`Error ${action}ing enrollment:`, err);
      alert('Hubo un error al procesar la solicitud.');
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}>
      <div className={`modal-dialog modal-dialog-centered ${isMaximized ? 'modal-fullscreen p-0 m-0' : 'modal-lg'}`}>
        <div className={`modal-content glassmorphism ${isMaximized ? 'h-100 rounded-0' : ''}`}>
          <div className="modal-header border-0 d-flex justify-content-between align-items-center">
            <h5 className="modal-title section-title fs-4 mb-0 d-flex align-items-center">
              <UserPlus size={24} className="me-2 text-primary" /> Inscripciones Pendientes
            </h5>
            <div className="d-flex align-items-center gap-2">
              <button 
                type="button" 
                className="btn-premium-action btn-sm p-1" 
                onClick={() => setIsMaximized(!isMaximized)}
                title={isMaximized ? "Restaurar" : "Maximizar"}
              >
                {isMaximized ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
              </button>
              <button type="button" className="btn-close-premium" onClick={onClose}>
                <X size={18} />
              </button>
            </div>
          </div>
          <div className="modal-body p-4">
            {loading ? (
              <div className="text-center p-5">
                <Loader2 size={40} className="animate-spin text-primary opacity-50" />
                <p className="mt-2 text-muted">Cargando solicitudes...</p>
              </div>
            ) : requests.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-hover premium-table align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Alumno</th>
                      <th>Diplomatura / Programa</th>
                      <th className="text-center text-secondary">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requests.map((req) => (
                      <tr key={req.id}>
                        <td>
                          <div className="fw-bold">{req.student_name || req.student_email}</div>
                          <div className="small text-muted">{req.student_email}</div>
                        </td>
                        <td>
                          <div className="text-primary small fw-bold">{req.diploma_name}</div>
                          <div className="text-dark fst-italic">Programa Completo</div>
                        </td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <button
                              className="btn btn-sm btn-success d-flex align-items-center gap-1 px-3"
                              onClick={() => handleProcess(req.id, 'approve')}
                              disabled={processingId === req.id}
                            >
                              {processingId === req.id ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />}
                              Aprobar
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1 px-3"
                              onClick={() => handleProcess(req.id, 'reject')}
                              disabled={processingId === req.id}
                            >
                              {processingId === req.id ? <Loader2 size={14} className="animate-spin" /> : <XCircle size={14} />}
                              Rechazar
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center p-5 text-muted fst-italic">
                <MessageSquare size={48} className="mb-3 opacity-25" />
                <p>No hay inscripciones pendientes de revisión.</p>
              </div>
            )}
          </div>
          <div className="modal-footer border-0">
            <button type="button" className="btn btn-secondary w-100" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentManagementModal;
